/**
 * this is the right menu for the dashboard
 *
 * Created by Tom on 1/6/18
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import cx from 'classnames'
import Parser from 'html-react-parser'
import {isEmpty} from '../../utility/utilities'

// action import
import {ActionCreator} from '../../actions/'

// component import
import PendingActionItem from '../PendingActionItem'
import SimpleLoader from '../SimpleLoader'

// style import
import './style.scss'

// icon imports
import BellIcon from '../../assets/svg/bell.svg'
import CloseIcon from '../../assets/svg/close.svg'
import CongratsImg from '../../assets/svg/congrats.svg'
import SpeakImg from '../../assets/svg/speak_directly.svg'

class RightMenu extends Component {

    _onOpenMenu() {
        const {setOpenRightMenu} = this.props
        // open the left menu
        setOpenRightMenu(true)
    }

    _onCloseMenu() {
        const {setOpenRightMenu} = this.props
        // close the left menu
        setOpenRightMenu(false)
    }

    _onCloseCongratsInfoBox() {
        const {setOpenCongratsInfoBox, dismissNotificationRequest, congratulate_message} = this.props
        const congratsId = congratulate_message.id

        //close the congratulation info box
        setOpenCongratsInfoBox(false)

        // Call api to dismiss this notification
        dismissNotificationRequest(congratsId)
    }

    _onRemovePendingActionItem(pendingActionId) {
        const {dismissNotificationRequest, removeNotificationsPendingAction} = this.props

        // Reomve pending action immediately from screen
        removeNotificationsPendingAction(pendingActionId)

        // Call api to dismiss this pending action
        dismissNotificationRequest(pendingActionId)
    }

    componentDidMount() {
        const {setOpenRightMenu, breakPointObj, getNotificationsData} = this.props
        breakPointObj.greaterThan.large &&  setOpenRightMenu(true)

        // Fetch notifications data
        getNotificationsData();
    }

    renderCongrats() {
        const {congratulate_message} = this.props
        if (isEmpty(congratulate_message)) return

        const {openCongratsInfo} = this.props
        const {title, sub_title, description} = congratulate_message;

        return (openCongratsInfo &&
            <div className="right-menu__top-container">
                <a
                    className="right-menu__top-container__close-text"
                    onClick={::this._onCloseCongratsInfoBox}>
                    Close
                </a>
                <div className="right-menu__wrapper">
                    <div className="right-menu__wrapper-left">
                        <img
                            src={CongratsImg}
                            alt="Man on top podium"/>
                    </div>
                    <div className="right-menu__wrapper-right">
                        <p className="right-menu__header-text">
                            {title}
                        </p>
                        <p className="right-menu__info-bold">
                            {sub_title}
                        </p>
                        <div className="right-menu__info-text">
                            {Parser(description)}
                        </div>
                    </div>
                </div>
            </div>)
    }

    renderPendingActions() {
        const {pending_actions} = this.props
        if (isEmpty(pending_actions)) return

        return (
            <div
                className="right-menu__middle-container">
                <p className="right-menu__header-text">
                    PENDING ACTIONS
                </p>

                {pending_actions.map(item => (
                    <PendingActionItem
                        key={item.id}
                        id={item.id}
                        title={item.title}
                        link1={{
                            text: item.link_text1,
                            url: item.link_url1
                        }}
                        link2={{
                            text: item.link_text2,
                            url: item.link_url2,
                        }}
                        show_dismiss={item.show_dismiss}
                        onRemove={() => this._onRemovePendingActionItem(item.id)}
                    />
                ))}
            </div>
        )
    }

    renderNews() {
        const {news_items} = this.props
        if (isEmpty(news_items)) return

        return (
            <React.Fragment>
                {news_items.map(item => {
                    const id = item.id
                    const img = item.image || SpeakImg
                    const title = item.title
                    const description = item.description

                    return (
                        <div className="right-menu__bottom-container" key={id}>
                          <div className="right-menu__wrapper">
                              <div className="right-menu__wrapper-left">
                                  <img src={img} alt="" />
                              </div>
                              <div className="right-menu__wrapper-right">
                                  <p className="right-menu__header-text">
                                      {title}
                                  </p>
                                  <div className="right-menu__info-text">
                                      {Parser(description)}
                                  </div>
                              </div>
                          </div>
                      </div>
                    )
                })}
            </React.Fragment>
        )
    }

    render() {
        const {openRightMenu, isLoading} = this.props

        // switch on/off classes based on the truthy value 'openRightMenu'
        const dynClass = cx('right-menu-container', {'right-menu-container--open': openRightMenu})

        return (
            <div className="right-menu-container-wrapper">
                <div
                    className="right-menu-open-container"
                    onClick={::this._onOpenMenu}>
                    <img
                        src={BellIcon}
                        className="right-menu-open-container__icon"
                        alt="Left menu close icon"/>
                </div>
                <div className={dynClass}>
                    <div className="right-menu-wrapper">
                        <div
                            className="right-menu-container__close-container"
                            onClick={::this._onCloseMenu}>
                            <img
                                src={CloseIcon}
                                className="right-menu-container__close-icon"
                                alt="Left menu close icon"/>
                        </div>
                        <div className="right-menu">
                            <SimpleLoader
                                num={2}
                                show={isLoading}
                                darkMode
                            />

                            {/* congrats info box */}
                            {this.renderCongrats()}

                            {/* pending actions container */}
                            {this.renderPendingActions()}

                            {/* bottom info container */}
                            {this.renderNews()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
RightMenu.propTypes = {
    setOpenRightMenu: PropTypes.func.isRequired,
    setOpenCongratsInfoBox: PropTypes.func.isRequired,
    openRightMenu: PropTypes.bool,
    openCongratsInfo: PropTypes.bool,
    breakPointObj: PropTypes.object,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        openRightMenu: state.componentState.openRightMenu,
        openCongratsInfo: state.componentState.openCongratsInfo,
        breakPointObj: state.browser,
        congratulate_message: state.notificationsState.congratulate_message,
        pending_actions: state.notificationsState.pending_actions,
        news_items: state.notificationsState.news_items,
        isLoading: state.notificationsState.isLoading,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        setOpenCongratsInfoBox: action.setOpenCongratsInfoBox,
        getNotificationsData: action.getNotificationsData,
        dismissNotificationRequest: action.dismissNotificationRequest,
        removeNotificationsPendingAction: action.removeNotificationsPendingAction,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightMenu)



// WEBPACK FOOTER //
// ./src/components/RightMenu/index.js